import { skipToken } from '@reduxjs/toolkit/query';
import { useGetCommercesQuery } from '../services/commerces.service';
import { CommerceFilters } from '../models';

interface UseCommercesProps {
  filters?: CommerceFilters;
  page: number;
  pageSize: number;
  skip?: boolean;
}

const useCommerces = ({
  filters,
  page,
  pageSize,
  skip = false,
}: UseCommercesProps) => {
  const { data, isLoading, error } = useGetCommercesQuery(
    skip
      ? skipToken
      : {
          paginated: { page, pageSize },
          filters,
        }
  );

  const count = data?.count ?? 0;
  const rows = data?.items ?? [];

  return {
    commerces: rows,
    totalItems: count,
    totalPages: count ? Math.ceil(count / pageSize) : 0,
    isLoading,
    error,
  };
};

export default useCommerces;
